"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccordions = exports.defaultThemeAccordions = void 0;
var tokens_1 = require("@prezzee/tokens");
exports.defaultThemeAccordions = {
    primary: {
        buttonBackgroundColor: tokens_1.colors.white,
        panelBackgroundColor: tokens_1.colors.white,
    },
    secondary: {
        buttonBackgroundColor: tokens_1.colors.gray100,
        panelBackgroundColor: tokens_1.colors.gray100,
    }
};
var createAccordions = function (accordionTransitions
// accordionTransitions: any
) {
    var mergedPrimary = __assign(__assign({}, exports.defaultThemeAccordions.primary), accordionTransitions === null || accordionTransitions === void 0 ? void 0 : accordionTransitions.primary);
    var mergedSecondary = __assign(__assign({}, exports.defaultThemeAccordions.secondary), accordionTransitions === null || accordionTransitions === void 0 ? void 0 : accordionTransitions.secondary);
    return {
        primary: mergedPrimary,
        secondary: mergedSecondary
    };
};
exports.createAccordions = createAccordions;
//# sourceMappingURL=accordions.js.map